import { SignupReducer } from "./SignUpReducer";
import { MenuReducer } from "./MenuReducer";
import { MenuItemReducer } from "./MenuItemReducer";
import { MenuItemOptionReducer } from "./MenuItemOptionReducer";
import { ItemOptionReducer } from "./ItemOptionReducer";
import { LocationReducer } from "./LocationReducer";
import { OrderReducer } from "./OrderReducer";
import { RoomReducer } from "./RoomReducer";
import { GeneralSettingReducer } from "./GeneralSettingReducer";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
    SignUpReducer: SignupReducer,
    MenuReducer: MenuReducer,
    MenuItemReducer: MenuItemReducer,
    MenuItemOptionReducer: MenuItemOptionReducer,
    ItemOptionReducer: ItemOptionReducer,
    LocationReducer: LocationReducer,
    OrderReducer: OrderReducer,
    RoomReducer:RoomReducer,
    GeneralSettingReducer:GeneralSettingReducer
});